import { Component, Input, OnInit, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { ConfirmationInput } from '@/shared/components/confirmation/confirmation.model';

import { StrapiGenericComponentService, StrapiParserService, OutagesService, SESSION_KEY } from '@/shared/services';
import { ActivatedRoute } from '@angular/router';
import { DiagnosticCheckService } from '@/shared/feature/diagnostic-check/services/diagnostic-check.service';
import { BaseComponent } from '@/shared/components/base/base.component';
import {
  ComponentElementsGenericComponent,
  ComponentElementsGlobalComponent,
} from '@/shared/interfaces/fault-article.interface';
import { AtomicArticleService } from '@/shared/feature/diagnostics-flow/services/atomic-article.service';

@Component({
  selector: 'vm-deflection-shell',
  templateUrl: './deflection-shell.component.html',
  standalone: true,
  imports: [],
})
export class DeflectionShellComponent extends BaseComponent implements OnInit {
  strapiGenericComponentService = inject(StrapiGenericComponentService);
  strapiParserService = inject(StrapiParserService);
  strapiService = inject(AtomicArticleService);
  outagesService = inject(OutagesService);
  diagnosticService = inject(DiagnosticCheckService);
  oauthService = inject(OAuthService);
  route = inject(ActivatedRoute);

  @Input() content: ConfirmationInput;

  strapiUID = 'dc_tv-error-codes_which-tv-box';
  actionCode = this.route.snapshot.paramMap.get('actionCode')?.toLocaleUpperCase() || '';
  workflowName = this.route.snapshot.paramMap.get('workflowName')?.toLocaleLowerCase() || '';
  isLoaded = false;

  ngOnInit() {
    this.checkOutages();
  }

  checkOutages() {
    this.outagesService.getOutages().subscribe((out) => {
      if (this.diagnosticService.numOutages(out, 'TV') > 0) {
        this.toUrl('/status/result');
      } else {
        this.getTVBoxes();
      }
    });
  }

  getTVBoxes() {
    this.diagnosticService.getAccountCheck().subscribe(() => {
      this.diagnosticService.setDiagnosticFlow(this.actionCode);
      this.getContent();
    });
  }

  getContent() {
    const ses = this.sessionService.getData();
    this.strapiService.getArticles(this.strapiUID).subscribe((res) => {
      const tvBoxContent = (res[0].elements[0] as ComponentElementsGlobalComponent).genericComponent.filter(
        (generic: ComponentElementsGenericComponent) =>
          !generic?.uid || ses?.df?.tvBoxTypes.includes(generic?.uid?.toLocaleLowerCase())
      );
      if (tvBoxContent.length > 3) {
        this.toUrl(`/tv-error-codes/${this.workflowName}/${ses?.df?.urlActionCode}which-tv-box`);
      } else {
        const selectedTVBoxType = tvBoxContent[1]?.ctas[0]?.Uid?.toLocaleLowerCase();
        this.sessionService.setData(SESSION_KEY.DIAGNOSTIC_FLOW, {
          ...this.sessionService.getData(SESSION_KEY.DIAGNOSTIC_FLOW),
          ...{ selectedTVBoxType, urlTVBoxType: `${selectedTVBoxType}/` },          
        });          
        this.toUrl(`/tv-error-codes/${this.workflowName}/${ses?.df?.urlActionCode}~initialise`);
      }       
    });
  }
}
